import L from 'leaflet';
import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';
import Mousetrap from 'mousetrap';
import intl from 'react-intl-universal';

// eslint-disable-next-line
import Editable from 'leaflet-editable';

import ConfirmationPopup from './../ConfirmationPopup';

import './PolygonDraw.css';

export class PolyDraw extends Component {
    constructor(props) {
        super(props);
    };
    componentDidMount() {
        this.props.appStore.mapState.element.addLayer(this.featureGroup);

        this.eventHandlers();
        Mousetrap.bind(['enter'], this.saveElement);

        if (this.props.appStore.pendingState.editing && this.props.appStore.pendingState.element.position) {
            this.initializePoly();
            this.applyMarkerClass();
            this.setState({
                drawing: false
            });
            this.props.appStore.disableDrawer(true);
        } else {
            this.startPoly();
        }

        if (this.props.appStore.isMobile && !this.props.appStore.pendingState.editing) {
            this.props.appStore.setConfirmationPopup(true);
        }
    };
    componentWillUnmount() {
        this.props.appStore.mapState.element.off('editable:created');
        this.props.appStore.mapState.element.off('editable:drawing:end');
        this.props.appStore.mapState.element.off('editable:editing');
        this.props.appStore.mapState.element.off('editable:vertex:new');
        this.props.appStore.mapState.element.off('editable:vertex:mouseout');
        this.props.appStore.mapState.element.off('editable:vertex:click');
        this.props.appStore.mapState.element.off('editable:vertex:deleted');
        this.props.appStore.mapState.element.removeLayer(this.polyLayer);
        this.props.appStore.disableDrawer(false);
        Mousetrap.unbind(['enter'], this.saveElement);
    };

    get vertices() {
        throw 'override required';
        return [];//for code intellisense
    }

    get polyLayer() {
        throw 'override required';
        return {};//for code intellisense
    }

    initializePoly() {
        throw 'override required';
    }
    startPoly() {
        throw 'override required';
    }

    applyMarkerClass(vertex) {
        if (vertex) {
            vertex._icon.classList.add('drawing-marker');
            return;
        }
        this.vertices.forEach((vertex) => {
            this.applyMarkerClass(vertex);
        });
    }

    renderContent(className) {
        return (
            <div className={className}>
                {this.props.appStore.pendingState.confirmationPopup &&
                <ConfirmationPopup
                    handleDone={this.drawEnd}
                    drawStarted={this.state.drawing}
                    defaultMessage={intl.get(className+".default_message")}
                    alternativeMessage={intl.get(className+".alternative_message")}
                />
                }
            </div>
        );
    }

}

@inject("appStore")
@observer
class PolygonDraw extends PolyDraw {
    constructor(props) {
        super(props);
        this.polygonLayer = null;
        this.featureGroup = new L.FeatureGroup();
        this.polygon = null;
        this.state = {
            drawing: false
        };
    };

    startPoly() {
        this.polygon = this.props.appStore.mapState.element.editTools.startPolygon();
    }

    get polyLayer() {
        return this.polygonLayer;
    }

    get vertices() {
        return this.polygon._latlngs[0].map((latlng) => {
            if (latlng.__vertex) return latlng.__vertex;
        }).filter(v => !!v)
    }

    initializePoly() {
        this.polygon = new L.polygon(this.props.appStore.pendingState.element.position, {
            color: this.props.appStore.pendingState.element.icon.color
        });
        this.polygonLayer = this.featureGroup.addLayer(this.polygon);
        this.polygon.enableEdit();
    }

    drawStart = (e) => {
        this.polygonLayer = e.layer;
        this.polygonLayer.setStyle({color: this.props.appStore.pendingState.element.icon.color});
        e.layer.addTo(this.props.appStore.mapState.element);
        this.props.appStore.tracking.event('Started Drawing Polygon');
    };
    drawEnd = () => {
        this.saveElement();
        this.setState({
            drawing: false
        });

        let latLngs = this.polygonLayer.toGeoJSON();
        let coords = latLngs.geometry.coordinates[0].slice(0, latLngs.geometry.coordinates[0].length - 1); // Remove last point which is a duplicate of the first due to Leaflet
        this.props.appStore.setPendingElementPosition(coords.map(longlat => {
            return {lat: longlat[1], lng: longlat[0]}
        }));
        if (!this.props.appStore.tryAutoSave()) {
            this.props.appStore.setSavePopup(true);
        }
        this.props.appStore.setConfirmationPopup(false);
    };
    saveElement = () => {
        if (this.polygon._latlngs[0].length > 2) {
            this.props.appStore.tracking.event('Saved Polygon')
            this.polygon.editor.tools.commitDrawing();
        }
    };
    eventHandlers = () => {
        this.props.appStore.mapState.element.on('editable:created', (e) => {
            this.drawStart(e);
            // this.setState({
            //     drawing: true
            // });
        });

        this.props.appStore.mapState.element.on('editable:drawing:end', (e) => {
            this.drawEnd(e);
        });

        this.props.appStore.mapState.element.on('editable:vertex:click', (e) => {
            e.cancel();
            let vertexIndex = e.vertex.getIndex();

            if (this.props.appStore.pendingState.editing) {
                if (e.vertex.getLastIndex() > 2) {
                    if (e.vertex.latlngs[vertexIndex].__vertex._icon.classList.contains('pending-delete-button')) {
                        e.vertex.delete();
                    } else {
                        e.vertex.latlngs[vertexIndex].__vertex._icon.classList.add('pending-delete-button');
                    }
                }
            } else {
                if (vertexIndex !== e.vertex.getLastIndex()) {
                    if (e.vertex.getLastIndex() > 2) {
                        if (e.vertex.latlngs[vertexIndex].__vertex._icon.classList.contains('pending-delete-button')) {
                            e.vertex.delete();
                        } else {
                            e.vertex.latlngs[vertexIndex].__vertex._icon.classList.add('pending-delete-button');
                        }
                    }
                }
                if (e.vertex.getIndex() === e.vertex.getLastIndex()) {
                    L.DomEvent.disableClickPropagation(e.sourceTarget._icon);
                    this.saveElement();
                }
            }
            this.applyMarkerClass();
        });

        this.props.appStore.mapState.element.on('editable:vertex:mouseout', (e) => {
            let vertexIndex = e.vertex.getIndex();
            if (e.vertex.latlngs[vertexIndex].__vertex._icon.classList.contains('pending-delete-button')) {
                e.vertex.latlngs[vertexIndex].__vertex._icon.classList.remove('pending-delete-button');
            }
        });

        this.props.appStore.mapState.element.on('editable:vertex:new', (e) => {
            if (e.vertex.getIndex() === e.vertex.getLastIndex()) {
                e.vertex.latlngs.forEach((vertex) => {
                    vertex.__vertex._icon.classList.remove('finish-button');
                });
                e.vertex._icon.classList.add('finish-button');
            }
            if (!this.state.drawing) {
                this.setState({
                    drawing: true
                });
            }
            this.applyMarkerClass(e.vertex);//not too big a deal - because it only happens on click, not drag (and may appear intentional) but this is not being applied
            this.props.appStore.disableDrawer(true);
        });

        this.props.appStore.mapState.element.on('editable:editing', (e) => {
            let pElement = this.props.appStore.pendingState.element;
            e.editTools.forwardLineGuide.options.color = pElement.icon.color;
            let latLngs = Object.assign({}, this.polygonLayer.toGeoJSON());
            if (this.props.appStore.pendingState.editing) {
                let coords = latLngs.features[0].geometry.coordinates[0].slice(0, latLngs.features[0].geometry.coordinates[0].length - 1); // Remove last point which is a duplicate of the first due to Leaflet
                this.props.appStore.setPendingElementPosition(coords.map(longlat => {
                    return {lat: longlat[1], lng: longlat[0]}

                }));
            } else {
                let coords = latLngs.geometry.coordinates[0].slice(0, latLngs.geometry.coordinates[0].length - 1);
                this.props.appStore.setPendingElementPosition(coords.map(longlat => {
                    return {lat: longlat[1], lng: longlat[0]}

                }));
            }
            this.applyMarkerClass();
        });
    };

    render() {
        return this.renderContent("PolygonDraw");
    }
}

export default PolygonDraw;



// WEBPACK FOOTER //
// ./src/scenes/MapContainer/components/PolygonDraw/index.js